module.exports = __webpack_public_path__ + "static/img/iphone_msptitle7.150bd2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle7.png
// module id = vfMj
// module chunks = 0